import { cn } from '@up2stay/up2promo-ui';
import type { ReactNode } from 'react';

interface AppPageLayoutProps {
  children: ReactNode;
  className?: string;
  /** Whether to include the standard horizontal padding (p-4 md:p-6). */
  withPadding?: boolean;
  /** Whether to include gap between stacked children. Defaults to true (gap-4). */
  withGap?: boolean;
}

/**
 * Standard layout wrapper: flex column with optional padding and gap between children.
 */
export function AppPageLayout({
  children,
  className,
  withPadding = true,
  withGap = true,
}: AppPageLayoutProps) {
  return (
    <div
      className={cn(
        'flex min-h-0 min-w-0 flex-col',
        withPadding &&
          cn(
            'px-[var(--app-page-padding-x)] md:pt-0',
            'pb-[var(--app-page-padding-bottom)]',
          ),
        withGap && 'gap-[var(--app-section-gap)]',
        className,
      )}
    >
      {children}
    </div>
  );
}
